/*
 * Initializes Swiper sliders for Meet the Advisors sections.
 * Targets containers with [data-meet-the-advisors] added by sections/section-meet-the-advisors.liquid
 */
(function () {
	function initMeetTheAdvisorsSliders() {
		if (typeof Swiper === 'undefined') return;

		var containers = document.querySelectorAll('[data-meet-the-advisors]');
		if (!containers.length) return;

		containers.forEach(function (container) {
			// Prefer controls inside the external navigation wrapper
			var wrapper = container.closest('.meet-the-advisors__wrapper') || container.parentElement;
			var navRoot = wrapper ? wrapper.querySelector('.meet-the-advisors__navigation') : null;
			var prevEl = navRoot ? navRoot.querySelector('.swiper-button-prev') : container.querySelector('.swiper-button-prev');
			var nextEl = navRoot ? navRoot.querySelector('.swiper-button-next') : container.querySelector('.swiper-button-next');
			var paginationEl = navRoot ? navRoot.querySelector('.swiper-pagination') : container.querySelector('.swiper-pagination');

			// eslint-disable-next-line no-new
			new Swiper(container, {
				slidesPerView: 1.13,
				spaceBetween: 8,
				watchOverflow: true,
				loop: true,
				keyboard: {
					enabled: true
				},
				a11y: {
					enabled: true
				},
				pagination: paginationEl ? {
					el: paginationEl,
					clickable: true
				} : undefined,
				navigation: prevEl && nextEl ? {
					prevEl: prevEl,
					nextEl: nextEl
				} : undefined,
				breakpoints: {
					768: {
						slidesPerView: 2.03
					},
					1025: {
						slidesPerView: 3.03
					}
				}
			});
		});
	}

	// Standalone: toggles only the CSS class for expanding/collapsing bios
	function initMeetTheAdvisorsShowMore() {
		var wrappers = document.querySelectorAll('.meet-the-advisors__wrapper');
		if (!wrappers.length) return;

		wrappers.forEach(function (wrapper) {
			wrapper.addEventListener('click', function (event) {
				var toggle = event.target.closest('.show-more');
				if (!toggle || !wrapper.contains(toggle)) return;

				var slideContent = toggle.closest('.meet-the-advisors__slide-content');
				var bio = slideContent ? slideContent.querySelector('.meet-the-advisors__bio') : null;
				if (!bio) return;

				bio.classList.toggle('is-expanded');
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initMeetTheAdvisorsSliders();
			initMeetTheAdvisorsShowMore();
		});
	} else {
		initMeetTheAdvisorsSliders();
		initMeetTheAdvisorsShowMore();
	}
})();
